module.exports = __webpack_public_path__ + "img/nwc.06a1ebd6.svg";